export type AccountingReportPeriodType = 'yearly' | 'quarterly' | 'monthly';

const ENGLISH_SHORT_MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

export function buildAccountingReportPeriodLabels(
    startDate: Date,
    endDate: Date,
    periodType: string
): string[] {
    if (!isValidDate(startDate) || !isValidDate(endDate) || startDate > endDate) {
        return [];
    }

    if (periodType.toLowerCase() === 'monthly') {
        const labels: string[] = [];
        const cursor = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        while (cursor <= end) {
            labels.push(`${ENGLISH_SHORT_MONTHS[cursor.getMonth()]} ${cursor.getFullYear()}`);
            cursor.setMonth(cursor.getMonth() + 1);
        }
        return labels;
    }

    if (periodType.toLowerCase() === 'quarterly') {
        const labels: string[] = [];
        let year = startDate.getFullYear();
        let quarter = Math.floor(startDate.getMonth() / 3) + 1;
        const endYear = endDate.getFullYear();
        const endQuarter = Math.floor(endDate.getMonth() / 3) + 1;
        while (year < endYear || (year === endYear && quarter <= endQuarter)) {
            labels.push(`Q${quarter} ${year}`);
            quarter++;
            if (quarter > 4) {
                quarter = 1;
                year++;
            }
        }
        return labels;
    }

    const labels: string[] = [];
    for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
        labels.push(year.toString());
    }
    return labels;
}

function isValidDate(value: Date): boolean {
    return value instanceof Date && !Number.isNaN(value.getTime());
}
